import { render, staticRenderFns } from "./SupplierChain.vue?vue&type=template&id=b516cee2&scoped=true&"
import script from "./SupplierChain.vue?vue&type=script&lang=js&"
export * from "./SupplierChain.vue?vue&type=script&lang=js&"
import style0 from "./SupplierChain.vue?vue&type=style&index=0&id=b516cee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b516cee2",
  null
  
)

export default component.exports